import React, {Component} from 'react';

import js from './js.js';
import piaochuangImg from './piaochuang.png'
import * as API from './../../api';

export default class piaochuang extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen : '',
            filePath : '',
            windowHight : '',
            windowWidth : '',
            windowHref : ''
        }
    }

    componentDidMount() {
        //获取
        API.getPiaochuang().then(result => {
            this.setState({
                ...result
            })
            if(this.state.id){
                var ad1=new js.AdMove("img1"); 
            }
        })

    }

    closediv = () =>{
       this.setState({
            isOpen : 'none'
       })

    }

    render() {
        return (
            <div id="img1" style={{ display : this.state.isOpen && this.state.isOpen == 1 ? '' : 'none' , zIndex : '999' , border : '1px solid rgb(204, 204, 204)',backgroundColor: 'white',position: 'absolute',top: '29px', fontSize: 0 }}>
                <div style={{position: 'relative'}}>
                    <a onClick={this.closediv.bind(this)} title="点击关闭" style={{height: 16 , textDecoration: 'none', color: '#fff', fontSize:25,position: 'absolute' , top: '10px' , right: '10px'}}>X</a>
                    <a href={this.state.windowHref} target="_blank" class="item">
                        <img 
                            src={this.state.filePath ? API.url+this.state.filePath : ''} 
                            width={this.state.windowWidth ? this.state.windowWidth : 300}
                            height={this.state.windowHight ? this.state.windowHight : 150}
                            />
                    </a> 
                </div> 
            </div> 
        )
    }
}
